import React from "react";

const LOGO_URL = "/logo_circle.png";

export function LogoIcon({ className = "w-10 h-10" }) {
  return (
    <img src={LOGO_URL} alt="AI Studdy Buddy" className={`${className} rounded-full object-cover flex-shrink-0`} />
  );
}

export function LogoBrand({ className = "", size = "default" }) {
  const sizes = {
    sm: { icon: "w-8 h-8", text: "text-base" },
    default: { icon: "w-10 h-10", text: "text-xl" },
    lg: { icon: "w-14 h-14", text: "text-2xl" },
    xl: { icon: "w-20 h-20", text: "text-3xl" },
  };
  const s = sizes[size] || sizes.default;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoIcon className={s.icon} />
      <span className={`font-heading font-extrabold ${s.text}`}>
        <span className="text-orange-500">Ai Studdy</span>{" "}
        <span className="text-blue-500">Buddy</span>
      </span>
    </div>
  );
}
